import { cn } from "@/lib/utils";

interface TaskInstructionHintProps {
  children: string;
  className?: string;
}

/**
 * Instructional pill under a quiz or worksheet prompt — tells the learner how
 * to interact with the current task.
 */
const TaskInstructionHint = ({
  children,
  className,
}: TaskInstructionHintProps) => (
  <p
    className={cn(
      "inline-flex w-fit max-w-full rounded-full bg-info-light px-3 py-1  font-semibold text-info-foreground",
      className
    )}
  >
    {children}
  </p>
);

export default TaskInstructionHint;
